import {EvButton} from '../form/EvButton';
import {useForm} from '@tanstack/react-form';
import {EvInputField} from '../form/EvInputField';

interface Props {
  text: string;
  labelCheckbox: string;
  labelButton: string;
  response: (confirmed: boolean) => void;
}

export function EvConfirmWithCheckbox(props: Props) {
  const form = useForm({
    defaultValues: {'confirmed': false},
    onSubmit: ({value}) => {
      props.response(value.confirmed);
    },
  });
  return <>
    <form onSubmit={async s => {
      s.preventDefault();
      await form.handleSubmit(s);
    }}>
      <div className="modal-body">
        <div className="row">
          <div className="float-left pl-4 pr-4">
            {props.text}
          </div>
        </div>
        <div className="row">
          <div className="float-left pl-4 pr-4">
            &nbsp;
          </div>
        </div>
        <div className="row">
          <label htmlFor="confirm" className="w-10/12 float-left pl-4 pr-4 mb-0!">
            {props.labelCheckbox}
          </label>
          <div className="w-2/12 float-left pl-4 pr-4">
            <form.Field name="confirmed">{field =>
              <EvInputField id="confirm"
                            type="checkbox"
                            field={field}>
              </EvInputField>
            }
            </form.Field>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="row">
          <div className="w-1/2 float-left text-left pl-4 pr-4">
            <EvButton type="reset" variant="default" onClick={() => props.response(false)}>
              Abbrechen
            </EvButton>
          </div>
          <div className="w-1/2 float-left text-right pl-4 pr-4">
            <form.Subscribe selector={(state) => state.values.confirmed}>
              {(confirmed) =>
                <EvButton type="submit" variant="success" disabled={!confirmed}>
                  {props.labelButton}
                </EvButton>
              }
            </form.Subscribe>
          </div>
        </div>
      </div>
    </form>
  </>;
}
